// frontend/src/pages/maintenance/MaintenanceDashboard.tsx

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, Tabs, TabList, Tab } from '@mui/joy';
import { FileText, Calendar } from '@phosphor-icons/react';
import { PageHelpButton } from '../../components/knowledge-base/PageHelpButton';
import ContractsList from './ContractsList';
import AppointmentsList from './AppointmentsList';

/**
 * Main dashboard for the Maintenance module with tabs for Contracts and Appointments.
 */
const MaintenanceDashboard: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active tab based on current path
  const getActiveTab = () => {
    if (location.pathname.includes('/maintenance/appointments')) {
      return 1;
    }
    return 0; // Default to contracts
  };

  const handleTabChange = (_event: React.SyntheticEvent | null, newValue: number | string | null) => {
    if (newValue === 0) {
      navigate('/maintenance/contracts');
    } else if (newValue === 1) {
      navigate('/maintenance/appointments');
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <Typography level="h2">
          Maintenance
        </Typography>
        <PageHelpButton />
      </Box>

      {/* Tabs */}
      <Tabs
        value={getActiveTab()}
        onChange={handleTabChange}
        sx={{ mb: 3 }}
      >
        <TabList>
          <Tab>
            <FileText size={18} style={{ marginRight: 8 }} />
            Contracts
          </Tab>
          <Tab>
            <Calendar size={18} style={{ marginRight: 8 }} />
            Appointments
          </Tab>
        </TabList>
      </Tabs>

      {/* Content based on route */}
      {getActiveTab() === 0 ? <ContractsList embedded /> : <AppointmentsList embedded />}
    </Box>
  );
};

export default MaintenanceDashboard;
